import { Component } from "react";
import SimpleRenderer from "./SimpleRenderer";
import { numberWithSpaces } from "../../../../utilities/formaters";
import { invoiceRowTypes } from "admin/shared/dictionary/enums";

import moment from "moment";
import PropTypes from "prop-types";

export default class InvoicesRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = { open: props.isOpen };
  }
  open = () => {
    this.setState({ open: true });
  };

  close = () => {
    this.setState({ open: false });
  };
  render() {
    const space = <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>;
    const planned = this.props.planned;
    var alloc = this.props.planned.Allocation;
    var total = Object.keys(alloc).reduce(
      (sum, key) => sum + parseFloat(alloc[key].Amount || 0),
      0,
    );
    return (
      <div style={{ marginBottom: "10px" }}>
        <SimpleRenderer label={moment(planned.Date).format("YYYY-MM-DD")} />
        Total amount: {numberWithSpaces(total, 2)} kr [
        {this.state.open ? (
          <span onClick={this.close} style={{ cursor: "pointer" }}>
            {" "}
            -{" "}
          </span>
        ) : (
          <span onClick={this.open} style={{ cursor: "pointer" }}>
            {" "}
            +{" "}
          </span>
        )}
        ]
        <br />
        {this.state.open ? (
          <span>
            {Object.entries(alloc).map(([key, value]) => {
              return (
                <div key={key}>
                  {space}
                  {invoiceRowTypes[key]}: {numberWithSpaces(value.Amount, 2)} kr
                </div>
              );
            })}
          </span>
        ) : undefined}
      </div>
    );
  }

  static propTypes = {
    planned: PropTypes.object,
    intermediationFee: PropTypes.number,
    invoiceFee: PropTypes.number,
    paymentKey: PropTypes.string,
    dateKey: PropTypes.string,
    isOpen: PropTypes.bool,
  };
}
